import React, { Component } from "react";
import { withRouter } from "react-router";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CardAvatar from "components/Card/CardAvatar.jsx";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { withStyles } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";

import {
  fetchCompanyAll,
  fetchUserAll,
  pushCompany,
  updateCompany,
  deleteCompany,
  proccessUpload,
  deleteUser
} from "../../api/company";
import { patchAddUser } from "api/login/index";

import moment from "moment";
import CompanyList from "../../granular/Company/companyList";
import UserList from "../../granular/Company/userList";
import UserProfileMasterCrud from "../../granular/Company/userprofileCrud";
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      email: "",
      name: "",
      brithday: "",
      gender: "",
      login_type: "",
      picture_background_url: "",
      picture_url: "",
      social_id: "",
      description: "",
      job: "",
      company_code: "",
      otp: "",
      userlevel: "",
      password: "",
      confirmPassword: "",
      companyList: [],
      search: "",

      datatable: [],
      openAdd: false,
      openEdit: false,
      msg_imgerr: "",
      msg_err: "",
      loader: null
    };
  }

  componentDidMount() {
    this.getDatatable();
  }

  restate = args => {
    this.setState({
      id: args[0],
      email: args[1],
      name: args[2],
      brithday: args[3],
      gender: args[4],
      login_type: args[5],
      picture_background_url: args[6],
      picture_url: args[7],
      social_id: args[8],
      description: args[9],
      job: args[10],
      company_code: args[11],
      userlevel: args[12],
      otp: args[13],
      openEdit: true
    });
    // this.updating()
  };

  updating = () => {
    let picture_url = "";

    proccessUpload(this.state.file_upload)
      .then(response => {
        picture_url = response.data.url;
        console.log(picture_url);
        picture_url = response.data.url;
        this.setState({ company_img: picture_url });
        updateCompany(this.state)
          .then(response => {
            if (response != null) {
              this.getDatatable();
              this.setState({
                company_name: "",
                company_address: "",
                company_telp: "",
                company_code: "",
                company_limit: "",
                company_email: "",
                company_img: "",
                openEdit: false
              });
            }
            this.setState({ msg_err: "" });
          })

          .catch(error => {
            this.setState({
              msg_err: "please fill all field above correctly!"
            });
            console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  getCompanyList = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchCompanyAll()
      .then(response => {
        if (response != null) {
          this.setState({ companyList: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchUserAll()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  handleDelete = id => {
    deleteUser(id)
      .then(response => {
        if (response != null) {
          this.getDatatable();
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleSubmit = () => {
    if (
      this.state.name == "" ||
      this.state.email == "" ||
      this.state.password == "" ||
      this.state.company_code == ""
    ) {
      this.setState({ msg_err: "Please input field correctly!" });
    } else if (this.state.password != this.state.confirmPassword) {
      this.setState({ msg_err: "Password not corrects!" });
    } else {
      patchAddUser(
        this.state.name,
        this.state.email,
        this.state.password,
        this.state.company_code
      )
        .then(response => {
          if (response != null) {
            this.getDatatable();
            this.setState({
              name: "",
              company_code: "",
              email: "",
              openAdd: false,
              password: "",
              confirmPassword: ""
            });
          }
          this.setState({ msg_err: "" });
        })
        .catch(e => {
          //console.log(e);
          this.setState({
            msg_err: "Cannot add user!"
          });
          // console.log("tidak berhasil");
          this.props.history.push("/pages/login#logout");
        });
    }
  };

  handleClose = (key, value) => {
    if (key === "openAdd") {
      if (value === true) {
        this.getCompanyList();
      }
      this.setState({
        name: "",
        company_code: "",
        email: "",
        openAdd: false,
        password: "",
        confirmPassword: ""
      });
    }
    this.setState({
      [key]: value
    });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    console.log(event.target.files[0]);
  };

  renderAddCompany = () => {
    console.log(localStorage.getItem("userlevel"), "levell");
    if (localStorage.getItem("userlevel") === "2") {
      return (
        <CardHeader color="rose" icon>
          <Button
            color="behance"
            round
            onClick={() => this.handleClose("openAdd", true)}
          >
            Add User
          </Button>
        </CardHeader>
      );
    } else {
      return <div />;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Users</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            {this.renderAddCompany()}
            <UserList
              datatable={this.state.datatable}
              handleDelete={this.handleDelete}
              restate={this.restate}
              loader={this.state.loader}
            />
          </Card>
          <Dialog
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Add User </DialogTitle>
            <DialogContent>
              <GridContainer>
                {/* <GridItem xs={12} sm={12} md={12}>
                  <Card profile>
                    <CardBody profile>
                      <title>Logo</title>

                      <Button variant="contained" component="label">
                        <CustomInput
                          inputProps={{
                            type: "file",
                            onChange: this.handleFileUpload
                          }}
                        />
                      </Button>
                    </CardBody>
                    <font color="red">{this.state.msg_imgerr}</font>
                  </Card>
                </GridItem> */}
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Name"
                    id="username"
                    inputProps={{
                      value: this.state.name,
                      onChange: e => this.handleChangeText("name", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_errname}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    inputProps={{
                      value: this.state.email,
                      onChange: e => this.handleChangeText("email", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_erremail}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel htmlFor="name-native-disabled">
                    Company Name
                  </InputLabel>
                  <Autocomplete
                    value={this.state.new}
                    onChange={(event, newValue) => {
                      this.setState({ new: newValue });
                    }}
                    inputValue={this.state.search}
                    onInputChange={(event, newInputValue) => {
                      let valuenya = newInputValue.split(") ");
                      this.setState({
                        search: newInputValue,
                        company_code: valuenya[0].slice(1)
                      });
                    }}
                    id="programmer-search"
                    options={this.state.companyList}
                    getOptionLabel={option =>
                      "(" + option.company_code + ") " + option.company_name
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Search"
                        //variant="filled"
                        style={{ width: "100%", paddingBottom: 1 }}
                      />
                    )}
                  />
                  <font color="red">{this.state.msg_errcompcode}</font>
                </GridItem>
                {/* <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "password",
                      value: this.state.password,
                      onChange: e => this.handleChangeText("password", e)
                    }}
                  />
                  <font color="red">{this.state.msg_errpassword}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Confirm Password"
                    id="confirm-password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "password",
                      value: this.state.confirmPassword,
                      onChange: e => this.handleChangeText("confirmPassword", e)
                    }}
                  />
                  <font color="red">{this.state.msg_errconfirmPassword}</font>
                </GridItem> */}
              </GridContainer>
              <font color="red">{this.state.msg_err}</font>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="default"
                round
              >
                Cancel
              </Button>
              <Button onClick={() => this.handleSubmit()} color="success" round>
                Save
              </Button>
            </DialogActions>
          </Dialog>
          {/* ini dia */}
          <Dialog
            maxWidth="md"
            open={this.state.openEdit}
            onClose={() => this.handleClose("openEdit", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Update User</DialogTitle>
            <DialogContent>
              <UserProfileMasterCrud datanya={this.state} />
            </DialogContent>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    //blocking: state.loader
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(withStyles(styles)(Users))
);
